import CustomButton from '../Button'
import { CircularProgress, IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'

interface Props {
    title: string
    content: string
    onAction: () => void
    onClose: () => void
    loading?: boolean
}

const TextModal = ({ title, content, onAction, onClose, loading = false }: Props) => {
    return (
        <div className="w-[60vw] md:w-fit flex flex-col gap-2 md:gap-4">
            <div className="flex items-center gap-2">
                <label className="text-secondary font-semibold text-sm md:text-base">{title}</label>
                <IconButton
                    onClick={onClose}
                    className="ml-auto p-0 text-primary"
                >
                    <ClearIcon />
                </IconButton>
            </div>
            <p className="text-sm md:text-base m-0">{content}</p>
            <CustomButton
                onClick={onAction}
                className="h-[36px]"
                disabled={loading}
            >
                {loading ? (
                    <CircularProgress
                        size={24}
                        className="text-secondary"
                    />
                ) : (
                    'Aceptar'
                )}
            </CustomButton>
        </div>
    )
}

export default TextModal
